module.exports = __webpack_public_path__ + "img/Artificiell intelligens.ae2e251e.svg";